module.exports = __webpack_public_path__ + "img/addplan.f84af1d4.svg";